import React, { useEffect } from "react";

import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

type TableToolbarProps<V> = {
  searchData: V[];
  onSearch: (data: V[]) => void;
  searchFields: (keyof V)[];
  labelBtn?: string;
  onClickBtn: () => void;
  classNameBtn?: string;
};

const TableToolbar = <V,>({
  searchData,
  onSearch,
  searchFields,
  labelBtn,
  classNameBtn,
  onClickBtn,
}: TableToolbarProps<V>) => {
  return (
    <Toolbar
      left={<ToolbarSearch data={searchData} onSearch={onSearch} searchFields={searchFields} />}
      right={<ToolbarButton label={labelBtn} className={classNameBtn} onClick={onClickBtn} />}
    />
  );
};

export default TableToolbar;

type ToolbarSearchProps<T> = {
  data: T[];
  onSearch: (data: T[]) => void;
  searchFields: (keyof T)[];
};

const ToolbarSearch = <T,>({ data, onSearch, searchFields }: ToolbarSearchProps<T>) => {
  useEffect(() => {
    onSearch(data);
  }, [data]);

  function searchObject(searchTerm: string) {
    const searchResults = data.reduce((results: T[], obj: T, i: number) => {
      let j: number;
      Object.entries(obj as object).find(([key, value]) => {
        if (!searchFields.includes(key as keyof T) || j === i) return false;

        if (value instanceof Object) {
          Object.values(value).find(v => {
            if (v?.toString().toLowerCase().includes(searchTerm.toLowerCase())) {
              results.push(obj);
              j = i;
              return true;
            }
            return false;
          });
        } else if (value?.toString().toLowerCase().includes(searchTerm.toLowerCase())) {
          results.push(obj);
          j = i;
          return true;
        }
        return false;
      });
      return results;
    }, [] as T[]);
    onSearch(searchResults);
  }
  return (
    <div className="p-toolbar-group-right">
      <div className="p-inputgroup">
        <span className="p-inputgroup-addon">
          <i className="pi pi-search" />
        </span>
        <InputText onChange={e => searchObject(e.target.value)} placeholder="Search..." />
      </div>
    </div>
  );
};

type ToolbarButtonProps = {
  label?: string;
  className?: string;
  onClick: () => void;
};
const ToolbarButton: React.FC<ToolbarButtonProps> = ({ label, className, onClick }) => {
  return <Button icon="pi pi-plus" label={label} className={className} onClick={onClick} />;
};
